<script lang="ts">
  import { isEmptyObject } from "@util/validations"
  import { QuestionnaireProps, Questionnaire, validateQuestionnaire } from "../models/Questionnaire"
  import FileUpload from "./TripQuestionnaireForm/FileUpload.svelte"
  import SingleChoiceInput from "./TripQuestionnaireForm/SingleChoiceInput.svelte"
  import MultiChoiceInput from "./TripQuestionnaireForm/MultiChoiceInput.svelte"
  import SubmitButton from "@components/ui/SubmitButton.svelte"
  import Form from "./ui/Form.svelte"
  import { put } from "@util/api"

  export let questionnaireProps: QuestionnaireProps
  export let updatePath: string

  let questionnaire = new Questionnaire(questionnaireProps)

  function submit() {
    return put(updatePath, {
      givenAnswers: questionnaire.givenAnswers.toJS(),
    })
  }
</script>

<Form data={questionnaire} validate={validateQuestionnaire} {submit} let:submitting let:errors>
  {#each questionnaire.givenAnswers.items as givenAnswer}
    {@const question = givenAnswer.question}
    <div data-role="question" class="grid lg:grid-cols-3 gap-inline-8 gap-block-2 mb-4 lg:mb-0 my-5">
      <label for={`answer-${question.id}`} class="font-bold text-gray-800 lg:col-span-3">
        {question.label}
        {#if !question.optional}
          <span class="text-sm text-red-700">*</span>
        {/if}
      </label>

      <div class="lg:col-span-2">
        {#if question.type === "text_field"}
          <input type="text" id={`answer-${question.id}`} bind:value={givenAnswer.textAnswer} />
        {:else if question.type === "text_area"}
          <textarea id={`answer-${question.id}`} bind:value={givenAnswer.textAnswer} />
        {:else if question.type === "single_choice"}
          <SingleChoiceInput bind:givenAnswer {question} />
        {:else if question.type === "multi_choice"}
          <MultiChoiceInput bind:givenAnswer {question} />
        {:else if question.type === "file_upload"}
          <FileUpload bind:givenAnswer />
        {/if}
      </div>

      {#if question.description}
        <div class="italic text-gray-700">{question.description}</div>
      {/if}
    </div>
  {/each}

  <div class="button-row">
    <SubmitButton {submitting} disabled={!isEmptyObject(errors)}>Proceed</SubmitButton>
    {#if !isEmptyObject(errors)}
      <span class="button-row-reminder">All required questions must be answered before you can proceed.</span>
    {/if}
  </div>
</Form>
